export default __webpack_public_path__ + "static/media/3.c197ab03.jpg";